import TextQuestionSurface from "./TextQuestionSurface";

export const SURFACE_9_LABEL = "What do they do for work?";
export const SURFACE_9_PLACEHOLDER = "Their job or role";
export const SURFACE_9_ERROR = "Even a rough idea helps.";

export default function Surface9(props) {
  return (
    <TextQuestionSurface
      current={5}
      label={SURFACE_9_LABEL}
      placeholder={SURFACE_9_PLACEHOLDER}
      errorCopy={SURFACE_9_ERROR}
      name="recipient_work"
      {...props}
    />
  );
}
